import { LayoutNavigationExtra, LayoutRoute } from 'src/app/_core/services/layout.service';
import { systemRoutes } from 'src/app/board/system/system-routes';
import { administrationRoutes } from 'src/app/board/administration/administration-routes';
import { webAdministrationRoutes } from 'src/app/board/web-administration/web-administration-routes';
import { activityRoutes } from 'src/app/board/activity/activity-routes';
import { beneficiaryRoutes } from 'src/app/board/beneficiary/beneficiary-routes';
import { contactRoutes } from 'src/app/board/contact/contact-routes';
import { subventionRoutes } from 'src/app/board/subvention/subvention-routes';
import { accountingRoutes } from 'src/app/board/accounting/accounting-routes';
import { exportsRoutes } from 'src/app/board/exports/exports-routes';
import { devToolsRoutes } from 'src/app/board/dev-tools/dev-tools-routes';
import { MenuDto } from 'src/graphql/generated-types';

export function hasMenuParametersCondition(menu: MenuDto, menuParams: {name: string, value: string}[]): boolean {
    const menuPageParam = menu.MenuPage.ListeParametres?.MenuPageParamDTO;

    return (!menuParams || (menuPageParam && menuParams.every(params => {
        return menuPageParam?.find(({Libelle}) => Libelle === params.name)?.Valeur === params.value;
    })));
}

export function hasMenuPageCodeRegex(menu: MenuDto, regex: string): boolean {
    return new RegExp(regex).test(menu.MenuPage.Code);
}

export interface MenuInterface {
    code: string;
    route: [LayoutRoute, LayoutNavigationExtra];
    // Liste des menuParams ( nom, valeur ) qui correspondent à cette route
    additionalConditionFn?: (menu: MenuDto) => boolean;
}

export const routes: MenuInterface[] = [
    ...systemRoutes,
    ...webAdministrationRoutes,
    ...activityRoutes,
    ...beneficiaryRoutes,
    ...contactRoutes,
    ...subventionRoutes,
    ...accountingRoutes,
    ...exportsRoutes,
    ...devToolsRoutes,
    ...administrationRoutes
];
